<script setup lang="ts">
import Guid from "@/app/types/common/guid";
import { makeDeepRef } from "@/components/composables/componentTools";
import BmDialog from "@/components/dialogs/BmDialog.vue";
import type { DialogEvents } from "@/components/mixins/dialogs";
import { useReactiveDialogScriptSetup } from "@/components/mixins/dialogs";
import { toRef } from "vue";
import messages from "@/plugins/i18n";
import { PlannedSalesVisit } from "@/app/services/generated/salesvisitService";
import userStore from "@/store/modules/userStore";
import { tenantService } from "@/app/services/extensions/tenantServiceExtended";
import PlannedSalesVisitHeader from "@/components/pages/orders/salesvisits/components/PlannedSalesVisitHeader.vue";

export interface CreateOrEditSalesVisitDialogProps {
  value: boolean;
  salesVisit?: PlannedSalesVisit;
}

export interface CreateOrEditSalesVisitEvents
  extends DialogEvents<PlannedSalesVisit> {}

const props = withDefaults(defineProps<CreateOrEditSalesVisitDialogProps>(), {
  salesVisit: () => {
    const newSalesVisit = new PlannedSalesVisit();
    newSalesVisit.id = Guid.create();
    newSalesVisit.userId = userStore.state.user?.id ?? Guid.createEmpty();
    newSalesVisit.date = tenantService.today;
    newSalesVisit.isPlannedTimeFlexible = true;
    newSalesVisit.durationMinutes = 60;

    return newSalesVisit;
  },
});
const emit = defineEmits<CreateOrEditSalesVisitEvents>();

const { accept, cancel } = useReactiveDialogScriptSetup<PlannedSalesVisit>(
  toRef(props, "value"),
  emit
);

const internalSalesVisit = makeDeepRef<PlannedSalesVisit>(
  props.salesVisit.clone()
);
</script>

<template>
  <bm-dialog
    :label="messages.sales_visit_details"
    :visible="value"
    @accept="() => accept(internalSalesVisit)"
    @cancel="cancel"
  >
    <planned-sales-visit-header
      v-model="internalSalesVisit"
      header-size="single-width"
      is-editing
    />
  </bm-dialog>
</template>
